import React, { Component } from 'react';
import { Col, FormGroup, ControlLabel, FormControl, Row, Glyphicon, Button, Alert, Checkbox } from 'react-bootstrap';
import moment from 'moment';

import FormSectionStatus from './FormSectionStatus';
import {updateLicense, toggleUpgradeOption, setUpgradeOption} from '../actions';
import { licenseTypes, statusTypes } from '../config/constants';
import { LicenseValidation } from "../validation/professionalValidation";

class License extends Component {
  constructor(props){
    super(props);
    this.handleLicenseChanges = this.handleLicenseChanges.bind(this);
    this.handleLicenseTypeChange = this.handleLicenseTypeChange.bind(this);
    this.handleLicenseNumberChange = this.handleLicenseNumberChange.bind(this);
    this.handleLicenseExpirationDateChange = this.handleLicenseExpirationDateChange.bind(this);
    this.handleUpgradeOptionToggle = this.handleUpgradeOptionToggle.bind(this);
    this.handleRemoveLicense = this.handleRemoveLicense.bind(this);
  }

  handleLicenseTypeChange(e){
    const updates = { type: e.target.value };
    this.handleLicenseChanges(updates);
    if (e.target.value !== 'LVN' && e.target.value !== 'PT' && this.props.upgradeOption)
      this.props.dispatch(setUpgradeOption(false));
  }

  handleLicenseNumberChange(e){
    const updates = { number: e.target.value };
    this.handleLicenseChanges(updates);
  }

  handleLicenseExpirationDateChange(e){
    const updates = { expirationDate: e.target.value };
    this.handleLicenseChanges(updates);
  }

  handleLicenseChanges(updates){
    const {dispatch, id} = this.props;
    dispatch(updateLicense(id, updates));
  }

  handleUpgradeOptionToggle(){
    this.props.dispatch(toggleUpgradeOption());
  }

  handleRemoveLicense(e){
    e.preventDefault();
    this.props.onRemoveLicense(this.props.id);
  }

  render() {
    const { id, type, number, expirationDate, applicationEndDate, nursingSynthesisStatus, upgradeOption } = this.props;
    const space = ' ';
    const validationState = new LicenseValidation().getValidationStatus(this.props);
    const expired = moment(applicationEndDate).isAfter(moment(expirationDate)) && typeof expirationDate !== 'undefined';
    // Show upgrade box if expiration date set, not expired, synthesis course added, and type LVN or PT
    const upgradeEligible = !expired && typeof expirationDate !== 'undefined' && nursingSynthesisStatus && (type === 'LVN' || type === 'PT');

    const getTypeOptions = () => {
      return Object.keys(licenseTypes).map((type) => {
        return (
          <option key={type} value={type}>{licenseTypes[type]}</option>
        )
      });
    };

    const getSectionStatus = () => {
      return validationState.section.status === statusTypes.SUCCESS ? null : <FormSectionStatus {...validationState.section}/>;
    };

    return (
      <React.Fragment>
        <Row>
          <Col md={4}>
            <FormGroup
              controlId={`license-${id}-type`}
            >
              <ControlLabel>
                License Type
              </ControlLabel>
              <FormControl
                componentClass="select"
                value={type}
                onChange={this.handleLicenseTypeChange}>
                <option value="">Select</option>
                { getTypeOptions() }
              </FormControl>
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup
              controlId={`license-${id}-number`}
            >
              <ControlLabel>
                License #
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="text"
                value={number}
                placeholder="License #"
                onChange={this.handleLicenseNumberChange}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup
              controlId={`license-${id}-expirationDate`}
            >
              <ControlLabel>
                Expiration Date
              </ControlLabel>
              <FormControl
                componentClass="input"
                type="date"
                value={expirationDate}
                placeholder="Enter Expiration Date"
                onChange={this.handleLicenseExpirationDateChange}
              />
              <FormControl.Feedback />
            </FormGroup>
          </Col>
          <Col md={1}>
            <FormGroup
              controlId={`license-${id}-remove`}
            >
              <ControlLabel>
                Remove
              </ControlLabel>
              <Button bsStyle="danger"
                      onClick={this.handleRemoveLicense}
                      style={{width: '100%'}}>
                <Glyphicon glyph="trash"/>
                {space}
              </Button>
            </FormGroup>
          </Col>
        </Row>
        <div className="clearfix"/>
        {expired &&
          <Alert bsStyle='warning'>
            License is or will be expired before the end of the application period. You WILL NOT receive points for an
            expired license but you may receive points for work experience accrued with a valid license.
          </Alert>
        }
        {!expired && typeof expirationDate !== 'undefined' && upgradeEligible &&
          <Alert bsStyle='info'>
            <p>
              Based on the information provided, you may be eligible to also apply for advanced placement into the ADN Program. This
              option recognizes prior education and allows waiver of one or more courses in the ADN program should space become available.
              Applicants are admitted under this option ONLY IF space becomes available in the program.
            </p>
            <p>
              PLEASE NOTE: If you select this option, you may be considered under two possible circumstances:
              <ol>
                <li>
                  You are selected in the regular pool and decline your space. If you get selected in the regular pool
                  you are forgoing your opportunity to waive one semester in the ADN program.
                </li>
                <li>
                  You were not selected in the regular pool but meet all of the minimum requirements AND there are spaces available.
                </li>
              </ol>
            </p>
            <Checkbox checked={upgradeOption} onChange={this.handleUpgradeOptionToggle}><strong>I would like to be considered as an advanced placement student</strong></Checkbox>
          </Alert>
        }
        {getSectionStatus()}
      </React.Fragment>
    );
  };
}

export default License;